export default {
  logging: 'Logging...',
  logCall: 'Log Call',
  editLog: 'Edit Log',
  select: 'Select a matching record',
  OnHold: 'On Hold',
  Ringing: 'Ringing',
  CallConnected: 'Call Connected',
  unknownUser: 'Unknown User',
  unknownNumber: 'Anonymous',
  unavailable: 'Unavailable',
  viewDetails: 'View Details',
  addEntity: 'Create New',
  addLog: 'Log',
  text: 'Text',
  call: 'Call',
  addContact: 'Add Contact',
  missedCall: 'Missed',
  inboundCall: 'Inbound',
  outboundCall: 'Outbound',
  from: 'From',
  to: 'To',
  hangup: 'Hang up',
  accept: 'Answer',
  toVoicemail: 'To Voicemail',
  anonymous: 'Anonymous',
  mergeToConference: 'Merge with active call',
  hold: 'Hold',
  unhold: 'Unhold',
  transfer: 'Transfer',
  reject: 'Reject',
  switchCall: 'Switch Call to this app',
  callSwitch: 'Call Switch',
  comfirmContext:
    "You're currently on an active call with {displayName}. Would you like to continue the call on this device?",
  comfirmCancelButton: 'Cancel',
  comfirmOKButton: 'Switch',
  ignore: 'Ignore',
  holdAndAnswer: 'Hold & Answer',
} as const;
